import DesignSystemContext from '../contexts/DesignSystemContext';

export default DesignSystemContext.Consumer;
